import angular from 'angular';

const name = 'mmsIncludeSpecialChar';
export const IncludeSpecialCharDirective = {
    name,
    directive: directive
};

function directive(UtilService) {
    'ngInject';
    return {
        restrict: 'A',
        scope: true,
        require: 'ngModel',
        link: function($scope, $element, $attrs, ngModel) {
            let includeCount = 0;
            $attrs.$observe(name, function(value) {
                includeCount = parseInt(value, 10);
                ngModel.$validate();
            });

            ngModel.$validators[name] = (modelValue, viewValue) => {
                return UtilService.countSpecialChar(viewValue) >= includeCount;
            };
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/directives/includeSpecialChar.directive.js